import React from 'react';
import { Grid } from '@material-ui/core';

export const ColorPatter = ({ classes }) => {
  return <React.Fragment>
  <Grid container direction="row" justify="space-between" alignItems="flex-start">
    <Grid item>
      <Grid container direction="row">
        <div className={classes.shape} style={{ backgroundColor: '#00c853' }} />
        <span className={classes.shapeLabel}>Quote requested&nbsp;</span>
        <div className={classes.shape} style={{ backgroundColor: '#bdbdbd' }} />{' '}
        <span className={classes.shapeLabel}>Quote supplied&nbsp;</span>
        <div className={classes.shape} style={{ backgroundColor: '#64dd17' }} /> <span className={classes.shapeLabel}>Paid&nbsp;</span>
        <div className={classes.shape} style={{ backgroundColor: '#78909c' }} /> <span className={classes.shapeLabel}>Approved&nbsp;</span>
        <div className={classes.shape} style={{ backgroundColor: '#ffd600' }} />{' '}
        <span className={classes.shapeLabel}>Attendance sheet submitted&nbsp;</span>
        <div className={classes.shape} style={{ backgroundColor: '#b388ff' }} /> <span className={classes.shapeLabel}>Booked&nbsp;</span>
        <div className={classes.shape} style={{ backgroundColor: '#84ffff' }} />{' '}
        <span className={classes.shapeLabel}>cancelled- no fees apply&nbsp;</span>
        <div className={classes.shape} style={{ backgroundColor: '#d50000' }} />{' '}
        <span className={classes.shapeLabel}>IP on holiday&nbsp;</span>
      </Grid>
    </Grid>
  </Grid>
</React.Fragment>;
};
